export const SCHEME_APPS = [
    {
        id: "netflix",
        name: "Netflix",
        color: "#E50914",
        text: "#fff",
        wordmark: "NETFLIX",
        letter: "N",
    },
    {
        id: "youtube",
        name: "YouTube",
        color: "#ffffff",
        text: "#FF0000",
        wordmark: "YouTube",
        letter: "▶",
    },
    {
        id: "prime",
        name: "Prime Video",
        color: "#0F4C81",
        text: "#00A8E1",
        wordmark: "prime video",
        letter: "p",
    },
    {
        id: "disney",
        name: "Disney+",
        color: "#0E1E42",
        text: "#fff",
        wordmark: "Disney+",
        letter: "D",
    },
    {
        id: "hbo",
        name: "Max",
        color: "#0A0F2C",
        text: "#fff",
        wordmark: "M A X",
        letter: "M",
    },
    {
        id: "apple",
        name: "Apple TV+",
        color: "#000000",
        text: "#fff",
        wordmark: "tv+",
        letter: "",
    },
    {
        id: "spotify",
        name: "Spotify",
        color: "#1DB954",
        text: "#000",
        wordmark: "Spotify",
        letter: "♫",
    },
    {
        id: "plex",
        name: "Plex",
        color: "#1F2326",
        text: "#EBAF00",
        wordmark: "plex",
        letter: "◆",
    },
    {
        id: "twitch",
        name: "Twitch",
        color: "#9146FF",
        text: "#fff",
        wordmark: "twitch",
        letter: "T",
    },
    {
        id: "svt",
        name: "SVT Play",
        color: "#222222",
        text: "#FFB800",
        wordmark: "SVT Play",
        letter: "S",
    },
    {
        id: "bbc",
        name: "BBC iPlayer",
        color: "#FF4C98",
        text: "#000",
        wordmark: "iPlayer",
        letter: "i",
    },
    {
        id: "browser",
        name: "Web Browser",
        color: "#374151",
        text: "#fff",
        wordmark: "://",
        letter: "@",
    },
];
export const SCHEME_INFO = [
    {
        id: "wifi",
        section: "Wi-Fi",
        items: [
            { label: "Network", value: "NendaGuest" },
            { label: "Password", value: "welcome2026" },
            { label: "Speed", value: "500 Mbps · symmetrical" },
        ],
    },
    {
        id: "reception",
        section: "Reception",
        items: [
            { label: "Front desk", value: "Dial 0 · 24 h" },
            { label: "Concierge", value: "Dial 1 · 07-23" },
            { label: "Housekeeping", value: "Dial 2 · 07-22" },
        ],
    },
    {
        id: "dining",
        section: "Dining",
        items: [
            {
                label: "Restaurant Lumen",
                value: "Breakfast 06:30-10:30 · Dinner 18-23",
            },
            { label: "Lobby Bar", value: "14:00 - 01:00" },
            { label: "In-room dining", value: "24 h · dial 3" },
        ],
    },
    {
        id: "wellness",
        section: "Wellness",
        items: [
            { label: "Spa & sauna", value: "07:00 - 22:00 · floor B1" },
            { label: "Pool", value: "06:00 - 22:00 · floor B1" },
            { label: "Gym", value: "24 h · floor B1" },
        ],
    },
    {
        id: "stay",
        section: "Stay",
        items: [
            { label: "Check-out", value: "12:00 · or skip via the Hotel app" },
            { label: "Late check-out", value: "On request · €40 until 16:00" },
            { label: "Laundry", value: "Pick-up before 09:00 · same-day return" },
        ],
    },
];
export function defaultSchemeContent(branding) {
    return {
        branding: { hotelName: branding.hotelName, city: branding.city },
        apps: SCHEME_APPS,
        stations: [],
        infoSections: SCHEME_INFO,
        actionLists: [],
        copy: {},
        images: {},
    };
}
export const CARE_APPS = [
    {
        id: "svt",
        name: "SVT Play",
        color: "#1F3D2A",
        text: "#fff",
        wordmark: "SVT Play",
        letter: "SP",
        tag: "Streaming",
    },
    {
        id: "tv4",
        name: "TV4 Play",
        color: "#C8463A",
        text: "#fff",
        wordmark: "TV4 Play",
        letter: "TP",
        tag: "Streaming",
    },
    {
        id: "spotify",
        name: "Spotify",
        color: "#3D6B49",
        text: "#fff",
        wordmark: "Spotify",
        letter: "Sp",
        tag: "Musik",
    },
    {
        id: "pussel",
        name: "Pussel",
        color: "#7A5A3C",
        text: "#fff",
        wordmark: "Pussel",
        letter: "Pu",
        tag: "Spel",
    },
    {
        id: "sudoku",
        name: "Sudoku",
        color: "#2C3A52",
        text: "#fff",
        wordmark: "Sudoku",
        letter: "Su",
        tag: "Spel",
    },
    {
        id: "foton",
        name: "Foton",
        color: "#A8C3A4",
        text: "#1F3D2A",
        wordmark: "Foton",
        letter: "Fo",
        tag: "Minnen",
    },
    {
        id: "bibel",
        name: "Bibel",
        color: "#1A1F1B",
        text: "#fff",
        wordmark: "Bibel",
        letter: "Bi",
        tag: "Andakt",
    },
    {
        id: "anhoriga",
        name: "Anhöriga",
        color: "#D4A574",
        text: "#1F3D2A",
        wordmark: "Anhöriga",
        letter: "An",
        tag: "Samtal",
    },
];
export const CARE_INFO = [
    {
        id: "meny",
        section: "Dagens meny",
        items: [
            {
                label: "Lunch · 12:00-13:00",
                value: "Köttbullar med gräddsås, pressgurka och lingon",
            },
            {
                label: "Middag · 17:30-18:30",
                value: "Fiskgratäng med dill och citron",
            },
            { label: "Kvällsfika · 20:00", value: "Serveras i salongen" },
        ],
    },
    {
        id: "aktiviteter",
        section: "Aktiviteter idag",
        items: [
            { label: "10:00 · Gymnastik", value: "Stora salen" },
            { label: "14:00 · Bingo", value: "Caféet" },
            { label: "15:30 · Högläsning", value: "Biblioteket" },
        ],
    },
    {
        id: "vecka",
        section: "Veckans program",
        items: [
            { label: "Tisdag", value: "Sångstund 14:00" },
            { label: "Onsdag", value: "Filmkväll 18:00" },
            { label: "Fredag", value: "Andakt 11:00" },
        ],
    },
    {
        id: "kontakt",
        section: "Kontakt & öppettider",
        items: [
            { label: "Reception", value: "Ring 0 · 08-20" },
            { label: "Sjuksköterska", value: "Ring 1 · dygnet runt" },
            { label: "Anhörigtelefon", value: "Ring 2 · 09-17" },
        ],
    },
    {
        id: "rad",
        section: "Goda råd",
        items: [
            { label: "Vid larm", value: "Tryck på det röda armbandet" },
            { label: "Måltider", value: "Servering i matsalen, plan 1" },
        ],
    },
    {
        id: "vader",
        section: "Vädret",
        items: [
            { label: "Idag", value: "Halvklart · 17°" },
            { label: "Imorgon", value: "Sol · 19°" },
        ],
    },
];
export function careSchemeContent(branding) {
    return {
        branding: { hotelName: branding.hotelName, city: branding.city },
        apps: CARE_APPS,
        stations: [],
        infoSections: CARE_INFO,
        actionLists: [],
        copy: {},
        images: {},
    };
}
export function defaultContentForScheme(key, branding) {
    return key === "care"
        ? careSchemeContent(branding)
        : defaultSchemeContent(branding);
}
export function defaultSchemeBinding(key, branding) {
    return { key, content: defaultContentForScheme(key, branding) };
}
